export function MissingDataIcon({ color = "#F8746B", className }: { color?: string; className?: string }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      strokeWidth="1.5"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M8 6V8.66667" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M6.90801 2.39307L1.50401 11.4157C1.3926 11.6087 1.33365 11.8274 1.33301 12.0502C1.33238 12.2729 1.39007 12.492 1.50037 12.6856C1.61067 12.8791 1.76972 13.0404 1.9617 13.1534C2.15368 13.2665 2.37191 13.3272 2.59467 13.3297H13.404C13.6267 13.3272 13.8448 13.2664 14.0367 13.1534C14.2286 13.0404 14.3876 12.8792 14.4978 12.6857C14.6081 12.4923 14.6658 12.2733 14.6653 12.0506C14.6647 11.828 14.6059 11.6093 14.4947 11.4164L9.09067 2.3924C8.97698 2.20474 8.81681 2.04956 8.62564 1.94187C8.43447 1.83417 8.21876 1.77759 7.99934 1.77759C7.77992 1.77759 7.56421 1.83417 7.37304 1.94187C7.18187 2.04956 7.0217 2.20474 6.90801 2.3924V2.39307Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M8 10.6672H8.0066" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
